<app-table
  #table
  storageKey="salaryListTable"
  [columns]="columns"
  [data]="list$ | async"
  [rowsPerPage]="defaultNumberOfRows"
  sortField="client"
  exportFilename="loneadministration"
  (pageChange)="paginatorTriggered($event)"
>
  <app-table-filter>
    <app-team-multi-selector localStorageKey="salary" (OnTeamsInit)="refreshList()"></app-team-multi-selector>
    <app-table-filter-item label="Klientansvarig">
      <app-user-selector [(userId)]="selectedClientResponsibleUserId" styleClass="min-w-48"></app-user-selector>
    </app-table-filter-item>
    <app-table-filter-item label="Utförande handläggare">
      <app-user-selector [(userId)]="selectedTaskUserId" styleClass="min-w-48"></app-user-selector>
    </app-table-filter-item>
    <app-table-filter-item label="Utbetalnings och rapporteringsmånad">
      <div class="flex">
        <app-month-selector [(month)]="selectedMonth" styleClass="min-w-32"></app-month-selector>
        <app-year-selector [(year)]="selectedYear" styleClass="min-w-32 ml-1"></app-year-selector>
      </div>
    </app-table-filter-item>
    <app-table-filter-item>
      <app-table-refresh-button [loading]="loading$ | async" (onClick)="refreshList()"></app-table-refresh-button>
    </app-table-filter-item>
    <app-table-filter-item>
      <p-checkbox
        [binary]="true"
        [(ngModel)]="includeAllDoneClients"
        (ngModelChange)="filterList()"
        [label]="includeFinishedLabel$ | async"
      ></p-checkbox>
    </app-table-filter-item>
  </app-table-filter>

  <ng-template tableTemplate="bodyCell" tableBodyCellField="client" let-client="rowData">
    <a (click)="onShowExistingClient(client.clientId)" class="cursor-pointer text-black">{{ client.client }}</a>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="corporateIdentity" let-client="rowData">
    <a (click)="onShowExistingClient(client.clientId)" class="cursor-pointer text-black">
      {{ client.corporateIdentity }}
    </a>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="customerNumber" let-client="rowData">
    <a (click)="onShowExistingClient(client.clientId)" class="cursor-pointer text-black">
      {{ client.customerNumber }}
    </a>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="paymentMaterial.when" let-data="rowData">
    <div
      class="cursor-pointer flex justify-start items-center truncate"
      (click)="onShowActivity(data.lonb)">
      <app-status-icon
        [status]="data.paymentMaterial.alertLevel.name"
        [tooltip]="data.paymentMaterial.alertLevel.description"
        [title]="data.paymentMaterial.when || ''"
      ></app-status-icon>
    </div>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="lonb.activity.alertLevel.description"
    let-activity="rowData.lonb"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="lonu.activity.alertLevel.description"
    let-activity="rowData.lonu"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="lone.activity.alertLevel.description"
    let-activity="rowData.lone"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="form.activity.alertLevel.description"
    let-activity="rowData.form"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>  
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="stat.activity.alertLevel.description"
    let-activity="rowData.stat"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="ovri.activity.alertLevel.description"
    let-activity="rowData.ovri"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template
    tableTemplate="bodyCell"
    tableBodyCellField="coll.activity.alertLevel.description"
    let-activity="rowData.coll"
  >
    <ng-container *ngTemplateOutlet="defaultCompositeColumn; context: { $implicit: activity }"></ng-container>
  </ng-template>
  <ng-template tableTemplate="bodyCell" tableBodyCellField="program" let-data="rowData">
    <div class="text-center">
      <app-bla-icon-button [composite]="data"></app-bla-icon-button>
    </div>
  </ng-template>

  <ng-template tableTemplate="emptyMessage">{{ statusText$ | async }}</ng-template>

  <ng-template tableTemplate="summary" let-data>
    <div class="relative">
      Antal aktuella klienter: {{ data.length }}
      <div class="absolute export-button-wrapper">
        <bl-frontend-button
          density="slim"
          [leadingIcon]="{name: 'download'}"
          text="Exportera lista"
          (onclick)="table.exportCSV()"
          title="Ladda ner listan för import till Excel"></bl-frontend-button>
      </div>
    </div>
  </ng-template>

  <ng-template #defaultCompositeColumn let-activity>
    <div
      class="flex justify-start items-center cursor-pointer"
      (click)="onShowActivity(activity)">
      <app-status-icon
        [status]="activity.activity.alertLevel.name"
        [title]="activity.activity.state.description"
        [tooltip]="activity.activity.alertLevel.description"
      ></app-status-icon>
      <app-activity-comment-icon [tooltip]="activity.activity.comment" classIfVisible="ml-2"></app-activity-comment-icon>
      <app-task-comment-icon [tooltip]="activity.task.comment" classIfVisible="ml-2"></app-task-comment-icon>
    </div>
  </ng-template>
</app-table>
